/**
 * Copyright (c) 2009 Sergiy Kovalchuk (serg472@gmail.com)
 *
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Following code is based on Element.mask() implementation from ExtJS framework (http://extjs.com/)
 *
 */
;
(function($) {

	/**
	 * Displays loading mask over selected element(s). Accepts both single and multiple selectors.
	 *
	 * @param label Text message that will be displayed on top of the mask besides a spinner (optional).
	 *                              If not provided only mask will be displayed without a label or a spinner.
	 * @param delay Delay in milliseconds before element is masked (optional). If unmask() is called
	 *              before the delay times out, no mask is displayed. This can be used to prevent unnecessary
	 *              mask display for quick processes.
	 */
	$.fn.mask = function(label, delay, maskClass) {
		if (!label) {
			var labels = ['One sec...', 'Standby...', 'Workin\' it...', 'Look kids, a deer!', 'Magic happening...', 'Doin\' Stuff...', 'Back after these messages...', 'Tap Tap Tap...', '(elevator music)', 'Un Momento por Favor...'];
			var inx = Math.floor(Math.random() * (labels.length + 1));
			label = labels[inx];
		}
		//label = '';
		$(this).each(function() {
			if (delay !== undefined && delay > 0) {
				var element = $(this);
				element.data("_mask_timeout", setTimeout(function() {
					$.maskElement(element, label, maskClass)
				}, delay));
			} else {
				$.maskElement($(this), label, maskClass);
			}
		});
	};

	/**
	 * Removes mask from the element(s). Accepts both single and multiple selectors.
	 */
	$.fn.unmask = function(duration) {
		$(this).each(function() {
			$.unmaskElement($(this), duration);
		});
	};

	/**
	 * Checks if a single element is masked. Returns false if mask is delayed or not displayed.
	 */
	$.fn.isMasked = function() {
		return this.hasClass("masked");
	};

	$.fn.cacheSize = function() {
		var size = null;
		$(this).each(function(i, e) {
			// cache this thing rather than re-create it for each line below
			var $this = $(this);

			if (!$this.is(':visible')) {
				$this.data('cached-size', null);
				size = {
					top: 0,
					left: 0,
					height: 0,
					width: 0
				};
				return size;
			}
			size = $this.position();

			// make sure we include the padding, borders, and margins
			var w = $this.outerWidth(false);
			var h = $this.outerHeight(false);
			size.height = h;
			size.width = w;

			$this.data('cached-size', size);
			$this.addClass('cached-size');
		});
		return size;
	};

	$.fn.getCachedSize = function(opts) {
		var opts = _.extend({
			refresh: false
		}, opts);

		var size = $(this).data('cached-size')
		if (!size || opts.refresh)
			size = $(this).cacheSize();
		return size;
	};

	$.maskElement = function(element, label, maskClass) {

		var isModal = element.is('.modal') || element.closest('.modal').length > 0;

		var size = element.getCachedSize();

		//if this element has delayed mask scheduled then remove it and display the new one
		if (element.data("_mask_timeout") !== undefined) {
			clearTimeout(element.data("_mask_timeout"));
			element.removeData("_mask_timeout");
		}

		if (size.height == 0 || size.width == 0)
			return;
		if (element.isMasked()) {
			return;
		}

		element.addClass("masked");

		var maskDiv = element.data('mask');
		var newMask = false;
		if (!maskDiv) {
			newMask = true;
			maskDiv = $('<div class="loadmask ' + ((maskClass) ? maskClass : '') + '"><div class="loading"><i class="icon-gear"></i><div class="loading-message">' + label + '</div></div></div>');
			element.data('mask', maskDiv);
		}

		//auto height fix for IE
		if (navigator.userAgent.toLowerCase().indexOf("msie") > -1) {
			maskDiv.height(element.height() + parseInt(element.css("padding-top")) + parseInt(element.css("padding-bottom")));
			maskDiv.width(element.width() + parseInt(element.css("padding-left")) + parseInt(element.css("padding-right")));
		}

		if (isModal) {
			maskDiv.css('width', size.width);
			maskDiv.css('height', size.height);
			if (newMask) {
				$(element).append(maskDiv);
			} else {
				maskDiv.css('display', '');
			}
		} else {
			maskDiv.css('top', size.top);
			maskDiv.css('left', size.left);
			maskDiv.css('width', size.width);
			maskDiv.css('height', size.height);
			if (newMask) {
				if (element.is('bodyxxx')) {
					element.append(maskDiv);
				} else {
					element.offsetParent().append(maskDiv);
				}
			} else {
				maskDiv.css('display', '');
			}
		}
	};

	$.unmaskElement = function(element, duration) {
		//if this element has delayed mask scheduled then remove it
		if (element.data("_mask_timeout") !== undefined) {
			clearTimeout(element.data("_mask_timeout"));
			element.removeData("_mask_timeout");
		}
		if (element.data('mask')) {
			var mask = element.data('mask');
			if (duration) {
				mask.hide('fade', {
					duration: duration
				});
			} else {
				mask.css('display', 'none');
			}

		}
		element.removeClass("masked");
	};

})(jQuery);
